var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDumptruck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M16.2,11.8l1.6,1.2l2.9,2.9l1.8-0.3v-1.6l-1.9-2.3l-1.7-4.7h-2.5C16,7.5,16.2,11.7,16.2,11.8z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9,6.9v9.7h1.2c0-1.1,0.7-2,1.7-2c0.9,0,1.7,0.9,1.7,2h0.3h1.8H23v-0.9h-0.4v-1.9c0-0.2-0.1-0.4-0.2-0.6 l-1.1-1.4l-1.8-5c-0.1-0.3-0.4-0.5-0.7-0.5h-2.4C16.1,6.4,15.9,6.6,15.9,6.9z M22.4,15.2h-1.4v-0.9h1.4V15.2z M16.5,10.6V7.8 c0-0.3,0.2-0.6,0.5-0.6h1.5c0.2,0,0.4,0.1,0.4,0.3l1.1,3.2c0,0.1,0,0.2,0,0.3c0,0.1-0.1,0.1-0.2,0.1h-2.8 C16.8,11.1,16.6,10.9,16.5,10.6L16.5,10.6z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000"
    },
    points: "1,14.2 3,16 7.3,5.5 4.5,5.5 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.6,
    y: 6.5,
    style: {
      fill: "#000"
    },
    width: 1.1,
    height: 6.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.2,
    y: 6.5,
    style: {
      fill: "#000"
    },
    width: 1.1,
    height: 6.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.1,
    y: 6.5,
    style: {
      fill: "#000"
    },
    width: 1.1,
    height: 6.8
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.6,5.5L3.2,16.1l0.7,0.6H5c0-1.2,0.7-2,1.7-2c0.9,0,1.7,0.9,1.7,2h1.9c0-1.2,0.7-2,1.7-2c0.9,0,1.7,0.9,1.7,2 h1.4V6.1c0-0.3-0.2-0.6-0.5-0.6H7.6z M12.8,6.3h1.5v7.3h-1.5V6.3z M10.4,6.3h1.5v7.3h-1.5V6.3z M8,6.3h1.5v7.3H8V6.3z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M10.6,16.7c0,1,0.7,1.8,1.5,1.8c0.8,0,1.5-0.8,1.5-1.8S12.9,15,12.1,15C11.3,15,10.6,15.7,10.6,16.7z  M11.3,16.7c0-0.5,0.3-0.9,0.7-0.9c0.4,0,0.7,0.4,0.7,0.9c0,0.5-0.3,0.9-0.7,0.9C11.7,17.6,11.3,17.2,11.3,16.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M5.3,16.7c0,1,0.7,1.8,1.5,1.8s1.5-0.8,1.5-1.8S7.6,15,6.8,15C6,15,5.3,15.7,5.3,16.7z M6,16.7 c0-0.5,0.3-0.9,0.7-0.9c0.4,0,0.7,0.4,0.7,0.9c0,0.5-0.3,0.9-0.7,0.9C6.4,17.6,6,17.2,6,16.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M17.3,16.7c0,1,0.7,1.8,1.5,1.8s1.5-0.8,1.5-1.8s-0.7-1.8-1.5-1.8C18,14.9,17.3,15.7,17.3,16.7z M18,16.7 c0-0.5,0.3-0.9,0.7-0.9c0.4,0,0.7,0.4,0.7,0.9c0,0.5-0.3,0.9-0.7,0.9C18.4,17.6,18,17.2,18,16.7z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDumptruck);
export default __webpack_public_path__ + "static/media/dumptruck.9ea6ea05c71840037f63c18ba312889e.svg";
export { ForwardRef as ReactComponent };